import {http} from "Services/Http/HttpClient";

export const checkAccountValidationToken = async(token: string) : Promise<unknown> => {
    return await http.get(`validate-user-email?token=${token}`)
}